import guests from './guests'

export default { guests }
